import { useMemo } from "react";

import { IdCell, type TableRow } from "@prequel/shared-components";

import { useListDatalakes } from "@/api/import/datalakes";
import type { ProviderResource } from "@/api/import/providers";
import { useListProviders } from "@/api/import/providers";
import ResourceTable, { type FilterField } from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";

const COLUMNS = ["Name", "Provider ID", "Created"];

const STATUS_OPTIONS = [
  { value: "true", label: "Enabled" },
  { value: "false", label: "Disabled" },
];

const mapProviderToRow = (provider: ProviderResource): TableRow => ({
  id: provider.id,
  to: `/import/providers/${provider.id}`,
  cells: [
    { value: provider.name },
    { value: <IdCell id={provider.id} full /> },
    { value: <Timestamp timestamp={provider.created_at} /> },
  ],
});

const ProvidersTable = () => {
  const { items: datalakes, isLoading: datalakesLoading } = useListDatalakes();

  const filterFields: FilterField[] = useMemo(
    () => [
      {
        key: "datalake",
        label: "Datalake",
        queryParam: "datalake_id",
        loading: datalakesLoading,
        radio: true,
        options: datalakes.map((datalake) => ({ value: datalake.id, label: datalake.name })),
      },
      {
        key: "status",
        label: "Status",
        queryParam: "is_enabled",
        radio: true,
        options: STATUS_OPTIONS,
      },
    ],
    [datalakes, datalakesLoading],
  );

  return (
    <ResourceTable<ProviderResource>
      columns={COLUMNS}
      useQuery={useListProviders}
      rowMapper={mapProviderToRow}
      emptyMessage="No providers configured."
      filterFields={filterFields}
    />
  );
};

export default ProvidersTable;
